import React, {Fragment} from 'react';
import {Tag, Flex, Goals, Link, Breadcrumbs, Transition, TransitionGroup, Settings, Layout, Icon, Button, Card} from 'components';
import {modal, shorten, map, config, useNamedSelector, redirect, openPopup} from 'helpers';
import {forbid} from 'store/session';
import css from './select-category.module.scss';

export function SelectCategory({ popup }) {
  popup.setClassName(config.sw ? 'xlarge' : 'wide');
  const { premium } = useNamedSelector('session.subscription');
  const projects = useNamedSelector('goals.projects');
  const categories = useNamedSelector('goals.categories');
  const select = ({ category, project }) => {
    redirect(category ? `/goals/set/?category=${encodeURIComponent(category)}` : `/goals/set/?project_id=${project}`);
    popup.close();
  }
  return (
    <Fragment>
      <Layout.Header>
        <Flex className="middle">
          <h5 className="pull-left">
            Select a category
            { config.sw && projects.length > 0 && ' or a project' }
          </h5>
          { config.sw &&
            <Button
              className="tiny"
              icon="plus"
              onClick={openPopup(!premium ? Settings.Upgrade : Goals.Projects.EditModal)}
              children="Project"
            />
          }
          <Icon className="secondary" name="close" onClick={popup.close} />
        </Flex>
      </Layout.Header>
      <div className={css.grid}>
        { map(categories, (label, name) =>
          <Card className="selectable" key={name} background={name} onClick={() => select({category: name})}>
            <div className={css.label}>{ label }</div>
          </Card>
        ) }
        <TransitionGroup component={null}>
          { config.sw && projects.map(project =>
            <Transition key={project.id} timeout={300}>
              { state =>
                <Card className={['selectable', css.project, state]} key={project.id} onClick={() => select({ project: project.id })}>
                  <Card.Body>
                    <Card.Text>{ shorten(project.name, 10) }</Card.Text>
                    <Card.Note>{ shorten(project.note, 10) || 'Project' }</Card.Note>
                  </Card.Body>
                  <Card.Toolbar className={css.toolbar} aria-haspopup="false">
                    <Icon name="pencil" onClick={openPopup(Goals.Projects.EditModal, { project})} />
                    <Icon name="trash" onClick={openPopup(Goals.Projects.RemoveMenu, { project})} />
                  </Card.Toolbar>
                </Card>
              }
            </Transition>
          ) }
        </TransitionGroup>
      </div>
      <Layout.Footer />
    </Fragment>
  );
}
